import Swiper, { Autoplay, Controller, EffectCreative} from "swiper";
document.addEventListener('DOMContentLoaded', () => {
  const faqAccordions = document.querySelectorAll('.faq__list .accordion')
  const header = document.querySelector('header')

  if(faqAccordions) {
    let activeIndex = null
    let swiper = null
    let throttle = false
    let timeout

    const sliderCreate = (index) => {
      if(window.innerWidth < 780) {
        const coords = faqAccordions[index].getBoundingClientRect()
        window.scrollTo({top: window.scrollY + coords.top - header.clientHeight, behavior: 'smooth'})
      }

      const slider = faqAccordions[index].querySelector('.faq__slider')
      const slides = slider.querySelectorAll('.faq__slide')
      const paginations = slider.querySelectorAll('.thumbs__item')
      let activeSlide = 0
      swiper = new Swiper(slider, {
        modules: [ EffectCreative, Autoplay, Controller],
        effect: "creative",
        speed: 1000,
        parallax: true,
        spaceBetween: 2,
        loop: slides.length > 1,
        creativeEffect: {
          prev: {
            translate: ["-20%", 0, -1],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        },
        allowTouchMove: false,
      })


      const startTimeout = () => {
        clearTimeout(timeout)
        if(throttle) {
          timeout = setTimeout(()=> {
            swiper.slideNext()
            throttle = false
          }, 30000)
        } else {
          timeout = setTimeout(()=> {
            swiper.slideNext()
          }, 10000)
        }
      }

      const slideChange = () => {
        const videos = slides[swiper.realIndex]?.querySelectorAll('video')
        if(videos) {
          setTimeout(()=> {
            videos.forEach(video => {
              video.currentTime = 0
              if(video.classList.contains('faq__video--mobile') && window.innerWidth < 780) {
                video.play()
              }
              if(!video.classList.contains('faq__video--mobile') && window.innerWidth >= 780) {
                video.play()
              }
            })
          }, 300)
        }
        const activeVideos = slides[activeSlide]?.querySelectorAll('video')
        if(activeVideos) {
          activeVideos.forEach(activeVideo => {
            activeVideo.pause()
          })
        }
        paginations[activeSlide]?.classList.remove('thumbs__item--active')
        setTimeout(() => {
          activeSlide = swiper.realIndex
          paginations[activeSlide]?.classList.add('thumbs__item--active')
        }, 500)
        startTimeout()
      }

      swiper.on('slideChange', slideChange)
      swiper.slideTo(1)
      slideChange()

      paginations.forEach((pagination, index) => {
        pagination.addEventListener('click', () => {
          swiper.slideTo(index + 1);
        })
      })
    }

    const sliderDestroy = () => {
      if(activeIndex === null) return
      clearTimeout(timeout)
      throttle = false
      swiper.destroy()
      const videos = faqAccordions[activeIndex].querySelectorAll('video')
      if(videos) {
        videos.forEach(video => {
          video.pause()
        })
      }
      activeIndex = null
    }
    faqAccordions.forEach((accordion, index) => {
      const faqContents = accordion.querySelectorAll('.faq__content')
      faqContents.forEach(faqContent => {
        const videos = faqContent.querySelectorAll('video')
        const sound = faqContent.querySelector('.faq-sound__input')
        if(videos && sound) {
          sound.addEventListener('change', () => {
            videos.forEach(video => {
              video.muted = !sound.checked
            })
          })
        }
      })
      accordion.querySelector('.accordion__head')?.addEventListener('click', (e) => {
        e.stopPropagation()
        if(index === activeIndex) {
          sliderDestroy()
          activeIndex = null
          return
        }
        if(activeIndex !== null) {
          faqAccordions[activeIndex]?.querySelector('.accordion__head')?.dispatchEvent(new Event('click'))
          if(swiper) sliderDestroy()
          setTimeout(() => {
            activeIndex = index
            sliderCreate(index)
          }, 500)
          return;
        }

        activeIndex = index
        setTimeout(() => {
          sliderCreate(index)
        }, 500)
      })
    })
  }

})